@if (isLoading() && isLoggedIn() || isVersionUpdateOverlayVisible() ) {
  <div class="app-loading-bar position-fixed top-0 start-0 w-100">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}

<div class="app-container">

  <!-- TOPBAR -->
  @if (isLoggedIn()) {
    <app-topbar  (toggleSidebar)="toggleSidebar()"></app-topbar>
  }

  <!-- MAIN AREA -->
  <div class="main-layout">

    <!-- SIDEBAR -->
    @if (isLoggedIn()) {
      <app-sidebar  [collapsed]="isSidebarCollapsed"></app-sidebar>
    }

    <!-- PAGE CONTENT -->
    <div class="content-area" [ngClass]="isLoggedIn()?'content-area-padding':''">
      <router-outlet></router-outlet>
      <app-file-upload-box [hidden]="!isFileUploadVisible()"></app-file-upload-box>
    </div>

  </div>

</div>

<app-spinner [isLoading]="isLoading() && !isLoggedIn()"></app-spinner>
